import { BaseServices, HttpMethod } from '@services/base'
import { PropostaApi } from '@store/refinanciamento/proposta/types'

export default (accessToken?: string) => {
  const pathname = process.env.REACT_APP_GET_DADOS_COMPLETOS_PROPOSTA
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  }

  const response = BaseServices.request<PropostaApi>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}
